import { ScaleElement } from '@scale/base-element';

class ScaleSlider extends ScaleElement {
  setup() {
    const track = this.ref('track');
    if (!track) return;

    const prev = this.ref('prev');
    const next = this.ref('next');

    if (prev) this.on('click', () => this.#scroll(-1), { target: prev });
    if (next) this.on('click', () => this.#scroll(1), { target: next });
    this.on('scroll', () => this.debounce('scroll', () => this.#updateNav(), 100), { target: track });

    this.#updateNav();
  }

  #scroll(direction) {
    const track = this.ref('track');
    const slide = track.firstElementChild;
    if (!slide) return;

    const slideWidth = slide.offsetWidth + (parseInt(getComputedStyle(track).gap) || 0);
    track.scrollBy({ left: direction * slideWidth, behavior: 'smooth' });
  }

  #updateNav() {
    const track = this.ref('track');
    if (!track) return;

    const atStart = track.scrollLeft <= 1;
    const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;

    const prev = this.ref('prev');
    const next = this.ref('next');
    if (prev) prev.disabled = atStart;
    if (next) next.disabled = atEnd;
  }

  onBlockSelect(e) {
    const block = this.querySelector(`#shopify-block-${e.detail.blockId}`);
    if (block) block.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
  }
}

if (!customElements.get('scale-slider')) {
  customElements.define('scale-slider', ScaleSlider);
}
